import React from 'react';
import Translate from "../../../../../../../components/Translate";
import { updateCompanyWorkingHours } from "../../../../../../../services/company/api";
import TimeInput from "../../../../../../../components-new/TimeInput";

const isValidTime = (value) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);

const WorkingHoursSettings = ({ client, workingHours, setWorkingHours }) => {
    const handleWorkingHoursChange = (e) => {
        const { name, value } = e.target;

        if (/^\d{0,2}:?\d{0,2}$/.test(value)) {
            setWorkingHours((prev) => ({ ...prev, [name]: value }));

            if (isValidTime(value)) {
                if (name === 'startHour') {
                    updateCompanyWorkingHours(client.id, value, workingHours.endHour);
                } else {
                    updateCompanyWorkingHours(client.id, workingHours.startHour, value);
                }
            }
        }
    };

    return (
        <div style={{ padding: '5px', margin: '10px' }}>
            <h2 style={{ fontSize: '16px', color: '#A4ADC1', marginBottom: '20px' }}>
                <Translate text="workingHours" />
            </h2>

            <TimeInput
                label="startHour"
                name="startHour"
                value={workingHours.startHour}
                onChange={handleWorkingHoursChange}
            />

            <TimeInput
                label="endHour"
                name="endHour"
                value={workingHours.endHour}
                onChange={handleWorkingHoursChange}
            />
        </div>
    );
};

export default WorkingHoursSettings;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/WorkingHoursSettings.jsx